module.exports = __webpack_public_path__ + "static/media/backgroundImage@2x.27eda2c3.png";